//
//  src/layouts/Index.js
//
import React  from "react";
import Layout from "./default/Default";
import './Index.css'


//
//  index.
//
export default function Index() {
    return ( <Layout /> );
}
